import { ForecastAction, ForecastState } from 'store/aggregated/forecast';
import { domainUtility } from 'utility';

const initialState: ForecastState = { allIds: [], byId: {} };

const forecastReducer = (
  state: ForecastState = initialState,
  action: ForecastAction,
): ForecastState => {
  switch (action.type) {
    case 'aggregated/forecast/ADD':
      return domainUtility.add(state, action.payload);
    case 'aggregated/forecast/SET':
      return domainUtility.set(state, action.payload);
    case 'aggregated/forecast/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'aggregated/forecast/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'aggregated/forecast/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default forecastReducer;
